import { useEffect, useMemo, useState } from 'react';

import { useGetContactsQuery } from '../../../services/sharedCompanyListV2';

export const useFetchContacts = ({ contactsSource, sharedList, user }) => {
  const collections = useMemo(() => [...user?.managingCollections, ...user?.allyingCollections], [user]);
  const isMyCollection = useMemo(
    () => collections.some((collection) => collection.id === sharedList?.collection?.id),
    [collections, sharedList?.collection?.id],
  );
  const networkId = isMyCollection ? sharedList?.collection?.id : collections[0]?.id;

  const myContactsDefaultParams = {
    page: 1,
    perPage: 10,
    networkId,
    contextualizedToSharedListId: sharedList.id,
    onlyMyContacts: true,
    maxContactsPerOrganization: 5,
  };
  const [queryParams, setQueryParams] = useState(myContactsDefaultParams);
  const { data = {}, isLoading, isFetching } = useGetContactsQuery(queryParams);
  const contactsCount = useMemo(
    () => Object.values(data?.entities || {}).reduce((acc, { contacts }) => acc + contacts.length, 0),
    [data],
  );

  useEffect(() => {
    if (contactsSource === 'my-contacts') {
      setQueryParams(myContactsDefaultParams);
    } else {
      setQueryParams({
        networkId: contactsSource,
        contextualizedToSharedListId: sharedList.id,
        page: 1,
        perPage: 10,
        maxContactsPerOrganization: 5,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactsSource]);

  return {
    queryParams,
    setQueryParams,
    data,
    isLoading,
    isFetching,
    networkId,
    contactsCount,
  };
};
